import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import React from 'react'
import EmptyView from '../../components/basic/EmptyView'
import Loading from '../../components/basic/Loading'
import MemberList from '../../components/MemberList'
import LocalizationContext from '../../context/LocalizationContext'

function MemberListScreen(props) {
    const { t } = React.useContext(LocalizationContext)
    const { memberStore, navigation } = props
    const [search, setSearch] = React.useState(undefined)
    const [isLoading, setIsLoading] = React.useState(true)

    React.useEffect(() => {
        const componentDidMount = async () => {
            try {
                await memberStore.listMembers(search, 0)
            }
            catch (e) {
                console.log(e)
            }
            setIsLoading(false)
        }

        componentDidMount()
    }, [navigation])


    React.useEffect(() => {
        const onSearchChange = async () => {
            try {
                await memberStore.listMembers(search, 0)
            }
            catch (e) {
                console.log(e)
            }
        }
        onSearchChange()
    }, [search])

    const handleOnEndReached = async () => {
        if (toJS(memberStore.members).length < toJS(memberStore.memberCount)) {
            try {
                await memberStore.listMoreMembers(search, toJS(memberStore.members).length)
            }
            catch (e) {
                console.log(e)
            }
        }
    }

    if (isLoading) {
        return <Loading />
    }

    if (!toJS(memberStore.members).length) {
        return <EmptyView t={t} />
    }


    return (
        <MemberList
            t={t}
            members={toJS(memberStore.members)}
            onEndReached={() => handleOnEndReached()}
            onChangeText={(value) => setSearch(value)}
            onMemberPress={(value) => { return navigation.push('MemberDetail', { memberId: value }) }}
        />
    )
}

export default inject('memberStore')(observer(MemberListScreen))